import { render, staticRenderFns } from "./side-panel.vue?vue&type=template&id=113a5450"
import script from "./side-panel.vue?vue&type=script&lang=js"
export * from "./side-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports